<template>
	<material-popup :dialogShowModel="showDialog" @escintent="showDialog = false">
		<material-card :fullscreenadapter="$vuetify.breakpoint.xsOnly" :icon="iconSet" :title="dialogTitle" :color="dialogType == 'alert' ? 'warning' : 'primary'" dismissable @dismissed="showDialog = false">
			<div slot="text-left" style="white-space: pre-line; word-break: break-word" v-html="dialogMessage"></div>
			<v-row v-if="dialogType == 'typeconfirm'">
				<v-col cols="12" xs="12">
					<v-text-field v-model="DialogConfirmText"></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="dialogSelectItems">
				<v-col cols="12" xs="12">
					<v-select dense v-bind:items="dialogSelectItems" :multiple="dialogType == 'select_multiple' ? true : false" v-model="DialogSelectID" item-text="name" item-value="id"></v-select>
				</v-col>
			</v-row>
			<template slot="actions">
				<v-col cols="6" xs="6" sm="3" v-if="dialogType != 'alert' && dialogType != 'advice'">
					<action-button large @click="dialogCancel()" outlined text="Annulla"></action-button>
				</v-col>
				<v-col cols="6" xs="6" sm="3" v-if="dialogType != 'typeconfirm'">
					<action-button large @click="dialogOk()" color="success" text="Ok"></action-button>
				</v-col>
				<v-col cols="12" xs="12" sm="3" v-if="dialogType == 'typeconfirm'">
					<action-button large @click="dialogOk()" color="success" text="Conferma"></action-button>
				</v-col>
			</template>
		</material-card>
	</material-popup>
</template>
<script>
export default {
	data: () => ({
		DialogSelectID: null,
	}),
	computed: {
		// dialog
		showDialog: {
			get() {
				return this.$store.getters.showDialog;
			},
			set(val) {
				if (!val) this.$store.commit("hideDialog");
			},
		},
		dialogType() {
			return this.$store.getters.dialogType;
		},
		dialogTitle() {
			return this.$store.getters.dialogTitle;
		},
		dialogMessage() {
			return this.$store.getters.dialogMessage;
		},
		DialogConfirmText: {
			get: function () {
				return this.$store.getters.dialogConfirmText;
			},
			set: function (value) {
				this.$store.commit("setDialogConfirmText", value);
			},
		},
		DialogMailText: {
			get: function () {
				return this.$store.getters.dialogMailText;
			},
			set: function (value) {
				this.$store.commit("setDialogMailText", value);
			},
		},
		dialogSelectItems() {
			return this.$store.getters.dialogSelectItems;
		},
		iconSet() {
			let icon = null;
			switch (this.dialogType) {
				case "alert":
					icon = "fas fa-exclamation-triangle";
					break;
				case "advice":
					icon = "far fa-smile-wink";
					break;
				case "confirm":
					icon = "fas fa-question-circle";
					break;
				case "typeconfirm":
					icon = "fas fa-clipboard-check";
					break;
				case "select_multiple":
					icon = "fas fa-clipboard-list";
					break;
				case "select":
					icon = "fas fa-clipboard-list";
					break;
				case "info":
					icon = "far fa-circle-question";
					break;
			}
			return icon;
		},
	},
	methods: {
		dialogConfirm() {
			this.$store.commit("dialogConfirm", this.DialogConfirmText);
			this.DialogConfirmText = "";
		},
		dialogOk() {
			this.$store.commit("dialogOk");
		},
		dialogSelect() {
			this.$store.commit("dialogSelect", this.DialogSelectID);
			this.DialogSelectID = null;
		},
		dialogCancel() {
			this.$store.commit("dialogCancel");
		},
	},
};
</script>
